var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5097",
    "data-name": "Group 5097",
    transform: "translate(-1407 -418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129-2",
    "data-name": "Ellipse 129",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(1407 418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_129_-_Outline",
    "data-name": "Ellipse 129 - Outline",
    d: "M21,1a20.006,20.006,0,0,0-7.785,38.429A20.005,20.005,0,0,0,28.785,2.571,19.874,19.874,0,0,0,21,1m0-1A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z",
    transform: "translate(1407 418)",
    fill: "#e1e6eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2571",
    "data-name": "Group 2571",
    transform: "translate(257 -93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8199",
    "data-name": "Path 8199",
    d: "M20,0A20.025,20.025,0,0,0,0,20H40A20.023,20.023,0,0,0,20,0",
    transform: "translate(1151 512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8200",
    "data-name": "Path 8200",
    d: "M20,40A20.021,20.021,0,0,0,40,20H0A20.023,20.023,0,0,0,20,40",
    transform: "translate(1151 512)",
    fill: "#db153b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/pl.e2ec9270e0a5cbcc896c642f2b931944.svg";
export { ForwardRef as ReactComponent };